/* eslint-disable no-undef */
/* prettier-ignore */
export function setupHotjar(event) {
  if (process.client) {
    setTimeout(() => {
      window.hj=window.hj||function(){(hj.q=hj.q||[]).push(arguments)}
      hj('event', event)
      hj('event', [event])
    }, 0)
  }
}
